import styled from 'styled-components'

import { TitleWrapper } from '@Components/CMS/Title'
import { up } from '@Globals/Style/breakpoints'

interface ShippingTextProps {
  center?: boolean
}

export const ShippingText = styled.div<ShippingTextProps>(({ center, theme }) => ({
  textAlign: center ? 'center' : 'left',

  '&, *': {
    color: theme.colors.grey,
    fontSize: '.875rem',

    [up('mobileStyleThreshold')]: {
      color: 'inherit',
      fontSize: '1rem',
    },
  },

  [TitleWrapper]: {
    h3: {
      marginBottom: '5px !important',
    },
  },
}))
